module.exports = __webpack_public_path__ + "img/1106b_1.1f589fe1.jpg";